__turbopack_context__.v({
  "className": "playfair_display_40e4baad-module__SeQEXG__className",
});
